import { useLanguage } from "../../../contexts";

// Traducción de interfaz del módulo (botones, encabezados, mensajes
// estructurales). El contenido narrativo de los catálogos (fichas de campo,
// nombres de tipologías/instrumentos/orígenes) queda en español a propósito
// — es texto técnico/regulatorio extenso que no se tradujo sin revisión.
//
// Soporta interpolación simple ({variable}) para no fragmentar oraciones en
// varias claves — fragmentar produce mala gramática en otros idiomas.
export function useWaterBalanceT() {
  const { translations } = useLanguage();
  return function t(key, vars) {
    let text = translations[key] || key;
    if (vars) {
      Object.entries(vars).forEach(([k, v]) => {
        text = text.replace(new RegExp(`\\{${k}\\}`, "g"), v);
      });
    }
    return text;
  };
}

export default useWaterBalanceT;
